import { request, post,downloadNew } from '@/plugins/request';
// 查询退款列表
export function getOperatorLog(data) {
    return post('/guarantee/v0.1/guarantee/guarantee/tg/getOperatorLog', data);
}